import React, { Component } from 'react';

class NextIcon extends Component {
  render() {
    return (<>&nbsp;&nbsp; <i className='fa fa-angle-right'></i><i className='fa fa-angle-right'></i></>);
  }
}

export default NextIcon;